var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"search-help-link"},[(_vm.helpUrl)?_c('a',{class:_vm.format,attrs:{"href":_vm.helpUrl}},[_vm._t("default",function(){return [_vm._v("help page on searching")]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }